import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Metadata } from '@fitscovery/partner-web/shared/models';
import { environment } from 'apps/partner-web/src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class MetaTagService {
    constructor(
        private meta: Meta,
        private title: Title) {
    }

    setTitle(title: string) {
        this.title.setTitle(title);
    }

    setTags(metadata: Metadata) {

        this.meta.updateTag({ name: 'twitter:site', content: metadata.site });
        this.meta.updateTag({ name: 'twitter:title', content: metadata.title });
        this.meta.updateTag({ name: 'twitter:description', content: metadata.description });
        this.meta.updateTag({ name: 'twitter:image', content: metadata.imageUrl! });
        this.meta.updateTag({ name: 'twitter:url', content: metadata.url });

        this.meta.updateTag({ property: 'fb:app_id', content: environment.facebook.appId });
        this.meta.updateTag({ property: 'og:site_name', content: metadata.site });
        this.meta.updateTag({ property: 'og:title', content: metadata.title });
        this.meta.updateTag({ property: 'og:description', content: metadata.description });
        this.meta.updateTag({ property: 'og:image', content: metadata.imageUrl! });
        this.meta.updateTag({ property: 'og:url', content: metadata.url });

        this.meta.updateTag({ property: 'site_name', content: metadata.site });
        this.meta.updateTag({ property: 'title', content: metadata.title });
        this.meta.updateTag({ property: 'description', content: metadata.description });
        this.meta.updateTag({ property: 'image', content: metadata.imageUrl! });
        this.meta.updateTag({ property: 'url', content: metadata.url });
    }
}